import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureName, BannerMessageListState } from '../../store/reducers/banner-message-list.reducer';

export const getBMListSettingsState = createFeatureSelector<BannerMessageListState>(featureName);

export const getBMListStickySettingsSelector = createSelector(getBMListSettingsState, (state: BannerMessageListState) => state.bmListState);
